import React from 'react'
import PropTypes from 'prop-types'
import { Form as FormikForm, Field as FormikField } from 'formik'
import { Box, Container, Flex } from 'rebass'

import {
  Button,
  ButtonOutline,
  FormGroup,
  Input,
  Label,
  Small,
  Textarea,
} from '../../components'

const Form = ({ errors, touched, dirty, handleReset, isSubmitting }) => (
  <Box
    is={FormikForm}
    method="post"
    action="thank-you"
    data-netlify="true"
    data-netlify-honeypot="bot-field"
    name="contact"
    my={3}
    mx="auto"
  >
    <p hidden>
      <input name="bot-field" />
    </p>
    <Container px={0} maxWidth={768}>
      <Flex flexWrap="wrap" mx={[0, -3]}>
        <FormGroup width={[1, 1 / 2]}>
          <Label htmlFor="name">Name</Label>
          <Input
            id="name"
            is={FormikField}
            type="text"
            name="name"
            placeholder="Enter your name"
          />
          {errors.name && touched.name && <Small>{errors.name}</Small>}
        </FormGroup>

        <FormGroup width={[1, 1 / 2]}>
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            is={FormikField}
            name="email"
            placeholder="Enter your email"
            type="email"
          />
          {errors.email && touched.email && <Small>{errors.email}</Small>}
        </FormGroup>

        <FormGroup width={1}>
          <Label htmlFor="message">Message</Label>
          <Textarea
            id="message"
            is={FormikField}
            name="message"
            placeholder="Enter your message"
            component="textarea"
          />
          {errors.message && touched.message && <Small>{errors.message}</Small>}
        </FormGroup>

        <FormGroup>
          <ButtonOutline
            type="button"
            onClick={handleReset}
            disabled={!dirty || isSubmitting}
            mr={2}
          >
            Reset
          </ButtonOutline>

          <Button type="submit" disabled={isSubmitting}>
            Submit
          </Button>
        </FormGroup>
      </Flex>
    </Container>
  </Box>
)

Form.propTypes = {
  errors: PropTypes.object,
  touched: PropTypes.object,
  dirty: PropTypes.bool,
  handleReset: PropTypes.func,
  isSubmitting: PropTypes.bool,
}

export default Form



// WEBPACK FOOTER //
// ./src/containers/Contact/Form.js